// extracted by mini-css-extract-plugin
export default {"select":"XxJHmmJM6bG8ukyUXXnj"};